module.exports = __webpack_public_path__ + "static/049_Gippsland-06699c66e68fb1578ef24df0a95737a9.png";